module.exports = __webpack_public_path__ + "static/media/gp.f7d4431a.webp";